/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */

import { requestCurrentTsPayIfNotRequested } from 'state/current-tspay/actions';
import { getCurrentTsPay, requestingCurrentTsPay } from 'state/current-tspay/selectors';
import TsPayPlanLoader from './tspay-plan-loader';
import Money from 'components/money';
import PlanName from 'components/plan-name';
import DateTime from 'components/date-time';
import Coupon from 'components/coupon';
import { Stack, Box, Text } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import SubscriptionStatus from 'components/subscription-status';
import Card from 'components/card';


const CurrentTsPayPlanCard = (props) => {
	let currentTsPay = props.currentTsPay;

	useEffect(() => {
		props.requestCurrentTsPay();
	}, []);

	if (!currentTsPay && !props.requesting) {
		return (
			<Card>
				<Card.Header heading='Plan details' />
				<Stack>
					<Card.Section>
						<DetailListItem label='Plan amount' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Current billing period' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Next billing date' />
					</Card.Section>
				</Stack>
			</Card>
		);
	}

	if (!currentTsPay && props.requesting) {
		return <TsPayPlanLoader />;
	}

	return (
		<Stack space='xxlarge'>

		    {currentTsPay.map((tsPay) => {
		    	return (<Card><Stack><Card.Section>
							<Box display='flex' padding='small' alignItems='center'>
								<Stack space='small'>
									<Box>
										<PlanName value={tsPay.subscription.plan_id} />
									</Box>
									<Box>
									    Price:
										<Money value={tsPay.subscription.plan_unit_price / 100} /> /{' '}
										{tsPay.subscription.billing_period} {tsPay.subscription.billing_period_unit}
						         	</Box>
						         	{tsPay.subscription.status == 'active' && (
						         	<Box>
									    Next Billing On <DateTime date={tsPay.subscription.next_billing_at} />
						         	</Box>
						         	)}

						         	{tsPay.subscription.coupons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Discounts
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{tsPay.subscription.coupons.map(({ coupon_id }) => {
													return (
														<Box key={coupon_id}>
															<Coupon couponId={coupon_id}></Coupon>
														</Box>
													);
												})}
											</Stack>
										</Box>
									)}
									<Box>
										<SubscriptionStatus status={tsPay.subscription.status} />
									</Box>
									{tsPay.subscription.status == 'future' && (
									<Box>
										Subscription start date:
										{<DateTime date={tsPay.subscription.start_date} format='Do MMM, YYYY' />}
						         	</Box>
						         	)}

								</Stack>
							</Box>

						</Card.Section></Stack></Card>)
		    })}

		</Stack>
	);
};

export default connect(
	(state) => ({
		currentTsPay: getCurrentTsPay(state),
		requesting: requestingCurrentTsPay(state),
	}),
	{
		requestCurrentTsPay: requestCurrentTsPayIfNotRequested,
	},
)(CurrentTsPayPlanCard);
